var React = require('react');

function ArrowIcon (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("clipPath",{"transform":"translate(0.25 0.25)"},React.createElement("rect",{"width":"19.69","height":"11.06","fill":"none"}))),React.createElement("g",{"clipPath":"url(#clip-path)","key":1},React.createElement("path",{"d":"M.75.75,9.82,10l6.09-6.2L19,.75","transform":"translate(0.25 0.25)","fill":"none","stroke":"#fff","strokeLinecap":"round","strokeWidth":"2"}))]);
}

ArrowIcon.defaultProps = {"data-name":"Layer 1","width":"20.2","height":"11.72","viewBox":"0 0 20.2 11.72"};

module.exports = ArrowIcon;

ArrowIcon.default = ArrowIcon;
